'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { usePortalRouter } from '~/features/global/portal';
import { useI18n } from '~/features/i18n';
import type { Step } from '~/features/layout/Steps';
import { Steps_ContextProvider_Stateless } from '~/features/layout/Steps/client';
import { PORTAL_RELATIVE_HREF_CART, PORTAL_RELATIVE_HREF_CHECKOUT } from '../hooks';

export type Checkout_Step = 'info' | 'extra' | 'account';

const Checkout_StepsProvider: React.FC<React.PropsWithChildren<{}>> = props => {
    const i18n = useI18n();
    const pathname = usePathname();
    const portalRouter = usePortalRouter();

    const STEPS = useMemo(() => [
        { label: i18n._('checkout.steps.0'), path: PORTAL_RELATIVE_HREF_CART },
        { label: i18n._('checkout.steps.1'), path: PORTAL_RELATIVE_HREF_CHECKOUT('info') },
        { label: i18n._('checkout.steps.2'), path: PORTAL_RELATIVE_HREF_CHECKOUT('extra') },
        { label: i18n._('checkout.steps.3'), path: PORTAL_RELATIVE_HREF_CHECKOUT('account') },
    ] as const satisfies Readonly<Step[]>, [i18n]); // prettier-ignore

    const currentIdx = useMemo(() => {
        return STEPS.findIndex(s => pathname.endsWith(s.path));
    }, [STEPS, pathname]);

    return (
        <Steps_ContextProvider_Stateless
            steps={STEPS}
            currentIdx={currentIdx}
            getStepURI={step => ({ pathname: portalRouter.relativePath(step.path) })}
        >
            {props.children}
        </Steps_ContextProvider_Stateless>
    );
};
export default Checkout_StepsProvider;
